import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import {
    CloseRounded,
    PaymentRounded,
} from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";

const _OfflinePaymentModal = ({
    open,
    onClose,
    submitting,
    handleConfirmOfflinePay,
    rawAmount,
    taxAmount,
    taxPrice,
    totalAmount,
    selectedGateway,
    getlabelOfRefrence,
    transactionReference,
    SetTransactionRefrence,
    transactionDescription,
    SetTransactionDescription,
}) => {
    return (
        <Dialog
            open={open}
            onClose={() => !submitting && onClose()}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 20px 45px rgba(0,0,0,0.12)'
                }
            }}
        >
            <Box component="form" onSubmit={handleConfirmOfflinePay}>
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        pb: 1.5,
                        borderBottom: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                        <Box
                            sx={{
                                width: 38,
                                height: 38,
                                borderRadius: 2.5,
                                bgcolor: 'rgba(28, 139, 156, 0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'primary.main'
                            }}
                        >
                            <PaymentRounded fontSize="small" />
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.05rem' }}>
                            ثبت اطلاعات پرداخت آفلاین
                        </Typography>
                    </Box>
                    <IconButton
                        size="small"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ color: 'text.secondary' }}
                    >
                        <CloseRounded fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 2.5 }}>
                    {/* Summary Box */}
                    <Box
                        sx={{
                            p: 2,
                            borderRadius: 3,
                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)',
                            border: '1px solid',
                            borderColor: 'divider',
                            mb: 2.5
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>مبلغ شارژ درخواستی:</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 700 }}>{toPriceWithComma(rawAmount)} تومان</Typography>
                        </Box>
                        {taxAmount > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>مالیات بر ارزش افزوده ({taxPrice}٪):</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 700 }}>{toPriceWithComma(taxAmount)} تومان</Typography>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 1, borderTop: '1px dashed', borderColor: 'divider' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'primary.main' }}>مجموع قابل واریز:</Typography>
                            <Typography variant="subtitle1" sx={{ fontWeight: 900, color: 'primary.main' }}>{toPriceWithComma(totalAmount)} تومان</Typography>
                        </Box>
                    </Box>

                    {selectedGateway?.Gateway?.Description && (
                        <Box sx={{ p: 1.8, borderRadius: 2.5, bgcolor: 'rgba(28, 139, 156, 0.06)', border: '1px solid', borderColor: 'rgba(28, 139, 156, 0.15)', mb: 2 }}>
                            <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.7, display: 'block' }}>
                                {selectedGateway?.Gateway?.Description}
                            </Typography>
                        </Box>
                    )}

                    <TextField
                        autoFocus
                        label={getlabelOfRefrence()}
                        placeholder="شماره فیش، کد پیگیری یا شماره سریال..."
                        value={transactionReference}
                        onChange={(e) => SetTransactionRefrence(e.target.value)}
                        fullWidth
                        required
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2.5 }, mb: 2 }}
                    />

                    <TextField
                        label="توضیحات اختیاری"
                        placeholder="هرگونه یادداشت برای واحد حسابداری..."
                        value={transactionDescription}
                        onChange={(e) => SetTransactionDescription(e.target.value)}
                        fullWidth
                        multiline
                        rows={2}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2.5 } }}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                    <Button
                        variant="text"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ borderRadius: 2.5, px: 2, color: 'text.secondary' }}
                    >
                        انصراف
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={submitting || !transactionReference}
                        sx={{
                            borderRadius: 2.5,
                            px: 3.5,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(28, 139, 156, 0.25)'
                        }}
                    >
                        {submitting ? <CircularProgress size={20} color="inherit" /> : "ثبت اطلاعات پرداخت"}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default _OfflinePaymentModal;
